import React, { useState, useEffect } from 'react';
import styles from "./modal.css";

let Modal = ({ isVisible, hide, component = null }) => {
  let [modalStyle, setModalStyle] = useState({ display: 'none' });

  useEffect(toggleVisibility, [isVisible]);

  function toggleVisibility() {
    if (isVisible) {
      setModalStyle({ display: 'block' });
      return;
    }
    setModalStyle({ display: 'none' });
  }

  return (
    <div className={styles["app-modal"]} style={modalStyle}>
      <div className={styles["app-modal-overlay"]} onClick={hide}>
        <div className={styles["component-centerer"]}>
          <div className={styles["app-modal-content"]} onClick={e => e.stopPropagation()}>
            {component}
          </div>
        </div>
      </div>
    </div>
  )
};

export default Modal;